import React, { useState, useEffect, useRef } from "react";
import "./Css/StaffRights.css";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { AiOutlineCamera } from "react-icons/ai";

import cameraicon from "../assets/cameraicon.png";
import {
  handleAphabetsChange,
  check_vaild_save,
  combiled_form_data,
  handleError,
  handleSuccess,
  empty_form,
  handleNumbersChange,
  handleSuccessSession,
  handleNumbersChangeRatting,
  goBack
} from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  save_update_testimonial,
  get_all_testimonial,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import { useLocation, useParams } from "react-router-dom";
import { Button } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import Breadcrumb from "../CommonJquery/Breadcrumb.js";

function AddTestimonial() {
  const location = useLocation();
  // const param = useParams();

  const { id } = useParams();

  const currentUrl = location.pathname.substring(1);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editStaffData, seteditStaffData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [subData, setSubData] = useState([]);
  const [designationpagelist, setDesignationPagelist] = useState([]);
  const [error_show, seterror_show] = useState("");
  const [editorData, setEditorData] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [testimonials, setshowtestimonial] = useState([]);
  const [testimonialsimage, setshowtestimonialimage] = useState([]);
  const [image, setImage] = useState(null);
  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      // if (editorData.length > 0) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      if (id !== undefined) {
        fd_from.append("main_id", id);
      }
      fd_from.append("message", editorData);
      fd_from.append("image_old", testimonialsimage);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(Response.data.message, "/View_Testimonial");
            setFormVisible(false);
            empty_form(form_data);
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
        });
      // } else {
      //   seterror_show("Please Fill The Mandatory Information");
      // }
    }
  };
  useEffect(() => {
    if (id !== undefined) {
      master_data_get();
    }
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", id);
    fd.append("flag", 3);
    await server_post_data(get_all_testimonial, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.data.length > 0) {
            setshowtestimonial(Response.data.message.data[0]);
            setshowtestimonialimage(Response.data.message.data[0].image);
            let image_link = Response.data.message.image_link;
            setImage(
              APL_LINK + image_link + Response.data.message.data[0].image
            );
            setIsImageUploaded(true);
          }
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleEditorChange = (event, editor) => {
    setEditorData(editor.getData());
  };

  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const fileInputRef = useRef(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        setIsImageUploaded(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <Header />

        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head" style={{ top: "0px" }}>
              <div className="pageNameDiv">
                {/* <p>
                  {location.pathname.includes("/Edit_Testimonial") ? (
                    <p>Edit Testimonial</p>
                  ) : (
                    <p>Add Testimonial</p>
                  )}
                </p>
                <img src={GreyArrow} alt="Rapid Car Leasing" /> */}
                <Breadcrumb
                  items={[
                    { label: "View Testimonial", path: "/View_Testimonial" },
                    {
                      label: location.pathname.includes("/Edit_Testimonial") ? "Edit Testimonial" : "Add Testimonial",
                      path: location.pathname,
                    },
                  ]}
                />
              </div>
              <Button
                onClick={goBack}
                startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="create_staffRights">
                <form className="createRightsForm" id="createRightsForm">
                  <div className="row m-0">
                    <div className="personalForm">
                      <div className="staffForm_container">
                        <div className="row m-0">
                          <div className="col-md-12">
                            {" "}
                            <div
                              className={`imageViewConter ${isImageUploaded ? "uploaded" : ""
                                }`}
                              title=" Image Size: 64x64 px"
                              style={{ cursor: 'pointer' }}
                              onClick={triggerFileInput}
                            >

                              {isImageUploaded ? (
                                <img
                                  src={image}
                                  alt="Uploaded"
                                  onClick={triggerFileInput}
                                  style={{ cursor: "pointer" }}
                                />
                              ) : (
                                <img
                                  src={cameraicon}
                                  alt="cameraicon"
                                  className="cameraIcon"
                                  onClick={triggerFileInput}
                                ></img>
                              )}
                              <input
                                type="file"
                                ref={fileInputRef}
                                accept="image/*"
                                name="image"
                                style={{ display: "none" }}
                                onChange={handleImageUpload}
                              />
                            </div>
                            <label className="imngTaggLine1">Upload Image</label>
                            <span style={{ fontSize: "12px", color: "#777", color: "red", }}>
                              Upload an Image of Size 64x64 px
                            </span>
                          </div>

                          <div className="col-md-5 mt-4">
                            <div className="inpContainer">
                              <label className="no_prsnl_id">
                                Full Name
                                <span>*</span>
                              </label>
                              <div>
                                <input
                                  type="text"
                                  name="name"
                                  placeholder="Full Name"
                                  defaultValue={testimonials.name || ""}
                                  minLength={3}
                                  maxLength={75}
                                  className="trio_name trio_mandatory input_field_custom2 input_field_customPadding form-control"
                                  onInput={handleAphabetsChange}
                                // defaultValue={editStaffData || ""}
                                />
                                <span className="condition_error"></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-5 mt-4" >
                            <div className="inpContainer">
                              <label className="no_prsnl_id">
                                City
                                <span>*</span>
                              </label>
                              <div>
                                <input
                                  type="text"
                                  name="city"
                                  defaultValue={testimonials.city || ""}
                                  placeholder="City"
                                  minLength={3}
                                  maxLength={75}
                                  className="trio_name trio_mandatory input_field_custom2 input_field_customPadding form-control"
                                  onInput={handleAphabetsChange}
                                // defaultValue={editStaffData || ""}
                                />
                                <span className="condition_error"></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-5 mt-2">
                            <div className="inpContainer">
                              <label className="no_prsnl_id">
                                Title
                                <span>*</span>
                              </label>
                              <div>
                                <input
                                  type="text"
                                  name="title"
                                  defaultValue={testimonials.title || ""}
                                  placeholder="Title"
                                  minLength={3}
                                  // maxLength={75}
                                  className=" trio_mandatory input_field_custom2 input_field_customPadding form-control"
                                  // onInput={handleAphabetsChange}
                                />
                                <span className="condition_error"></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-5 mt-2">
                            <div className="inpContainer">
                              <label className="no_prsnl_id">
                                Rating
                                <span>*</span>
                              </label>
                              <div>
                                <input
                                  type="text"
                                  name="ratting"
                                  defaultValue={testimonials.ratting || ""}
                                  placeholder="Rating"
                                  className=" trio_mandatory input_field_custom2 input_field_customPadding form-control"
                                  onInput={handleNumbersChangeRatting}
                                />
                                <span className="condition_error"></span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12 mt-2">
                            <div className="inpContainer">
                              <label className="no_prsnl_id">
                                Description
                                <span>*</span>
                              </label>
                              <div>
                                <textarea
                                  name="messagesss"
                                  defaultValue={testimonials.message || ""} // Use `value` instead of `defaultValue` for controlled components
                                  placeholder="Enter your message"
                                  minLength={3}
                                  maxLength={500}
                                  className=" trio_mandatory  form-control"
                                  // onChange={(e) => handleAphabetsChange(e)} // Ensure correct event handler usage
                                />
                                <span className="condition_error"></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="createRightBtnDiv mb-5">
                          <button
                            className="btn btn-primary Create_Designation_Btn btnSave"
                            type="button"
                            onClick={() =>
                              handleSaveChangesdynamic(
                                "createRightsForm",
                                save_update_testimonial
                              )
                            }
                          >
                            {location.pathname.includes("/Edit_Testimonial")
                              ? "Update"
                              : "Add"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddTestimonial;
